import styled from 'styled-components'
import { Button, colors } from '@diversioteam/diversio-ds'

export const StyledFeedbackButton = styled(Button)`
    border: none !important;
    background-color: transparent !important;
    color: var(--foreground) !important;
    margin-right: -8px;

    @media (min-width: 768px) {
        margin-right: -16px;
    }

    &:hover:not(:disabled) {
        background-color: ${colors.primaryGray1} !important;
        color: ${colors.primary90} !important;
    }
    &:focus {
        outline: none;
    }
`
